import { Box, useTheme } from "@mui/material";

type Props = {
	selected: boolean;
};

export const RadioDot = ({ selected }: Props) => {
	const theme = useTheme();
	return (
		<Box
			sx={{
				width: 20,
				height: 20,
				borderRadius: "50%",
				flexShrink: 0,
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				bgcolor: selected ? theme.palette.blue[500] : "transparent",
				border: selected ? "none" : `2px solid ${theme.palette.grey[300]}`,
			}}
		>
			{selected && (
				<Box
					sx={{
						width: 8,
						height: 8,
						borderRadius: "50%",
						bgcolor: theme.palette.darkmodeText.white,
					}}
				/>
			)}
		</Box>
	);
};
